import { CONTACT_TOPIC } from "@bridewell/shared";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ContactPage } from "@/features/marketing/contact-page";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/contact")({
  // `?topic=business` from the pricing page and the billing page's Business card pre-selects the subject.
  validateSearch: z.object({ topic: z.enum(CONTACT_TOPIC).optional() }),
  head: SEO.contact,
  component: () => {
    const { topic } = Route.useSearch();
    return <ContactPage topic={topic} />;
  },
});
